import type {TypedUseSelectorHook} from "react-redux";
import {useStore, useDispatch, useSelector} from "react-redux";
import store from "../store/store";

export type OutlawStore = typeof store;
export type OutlawState = ReturnType<OutlawStore['getState']>;
export type OutlawDispatch = OutlawStore['dispatch'];

export const useRootDispatch: () => OutlawDispatch = useDispatch;
export const useRootSelector: TypedUseSelectorHook<OutlawState> = useSelector;
export const useRootStore: () => OutlawStore = useStore;